import { render, staticRenderFns } from "./ReportsInvoiceItemsDetail.vue?vue&type=template&id=51bc32b3&scoped=true&"
import script from "./ReportsInvoiceItemsDetail.vue?vue&type=script&lang=js&"
export * from "./ReportsInvoiceItemsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportsInvoiceItemsDetail.vue?vue&type=style&index=0&id=51bc32b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc32b3",
  null
  
)

export default component.exports